module.exports = __webpack_public_path__ + "static/media/vegitables_33.0a4aa70c.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_33.csv
// module id = 617
// module chunks = 0